import React from 'react';
import Icon from '../../../../components/AppIcon';

const LoginFooter = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <div className="mt-8 text-center">
      {/* Security Badge */}
      <div className="flex items-center justify-center space-x-2 mb-4">
        <Icon name="Shield" size={16} className="text-success" />
        <span className="text-xs text-muted-foreground">
          Secured with SSL encryption
        </span>
      </div>

      {/* Copyright */}
      <p className="text-xs text-muted-foreground">
        © {currentYear} CarWash Manager. All rights reserved.
      </p>

      {/* Version */}
      <p className="text-xs text-muted-foreground/60 mt-1 font-mono">
        v2.1.0
      </p>
    </div>
  );
};

export default LoginFooter;